<template>
	<div>
		
		<div class="row mt-4">
			<div class="col-md-6">
				<input v-model="query.generic" class="input form-control"
								@keypress.enter="find()"
								placeholder="Pesquisar por conteúdo">
				<search-icon @click="find()" class="icon icon-within"/>
			</div>
			
			<div class="col-md-6">
				<button class="btn btn-outline px-3 mr-2"
								:class="{ 'btn-outline-active': showFilter }"
								@click="showFilter = !showFilter">
					Filtros
					<chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
				</button>
				
				<button v-if="changeQuery" @click="find()" class="btn btn-link">
					Aplicar filtros ({{ numberOfBadges }})
				</button>
			</div>
		</div>
		
		<!-- Badge of filters -->
		<div class="row">
			<div class="col-md-12">
				<BadgeFilters :filters="[filterGeneric, filterCompany, filterStartDate, filterEndDate, filterOrigin, filterCnpjProvider]"
											:query="query"
											:amountChanged="updateNumberOfBadges"
											@clearAllBadges="$nextTick(() => find())"
											@clearBadge="$nextTick(() => find())"/>
			</div>
		</div>
		
		<div v-show="showFilter">
			<div class="row mt-4">
				<div class="col-md-4">
					<label for="alert-cnpjs">Estabelecimento</label>
					<Select2 id="alert-cnpjs" v-model="query.cnpj" :options="filterCompany"/>
				</div>
        
        <div class="col-md-4">
          <label for="alert-origin">Origem</label>
          <Select2 id="alert-origin" v-model="query.origin" :options="filterOrigin"/>
        </div>
        
				<div class="col-md-4">
					<label for="alert-cnpj-provider">CNPJ do Prestador</label>
					<input id="alert-cnpj-provider" :value="query.cnpjProvider"
                 @input="setCnpjProvider($event)"
                 class="form-control" v-mask="'XX.XXX.XXX/XXXX-##'">
				</div>
			</div>
      
      <div class="row mt-4">
        <div class="col-md-6">
          <label for="alert-start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" class="form-control" id="alert-start-date">
        </div>
        
        <div class="col-md-6">
          <label for="alert-end-date">Data final</label>
          <input v-model="query.endDate" type="date" class="form-control" id="alert-end-date">
        </div>
      </div>
		</div>
		
		<hr>
    <!-- buttons  -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button class="btn btn-primary mt-1 mr-1"
                :disabled="disabledDownload"
                @click="download"
        >
          Download
        </button>
      </div>
    </div>
    
		<div class="row mt-4">
			<div class="col-md-6 mt-2">
				<strong>{{ infoTotalModels }}</strong>
        <button class="btn btn-outline ml-3 mb-1"
                v-if="alerts.length > 0"
                @click="changeCheckAll"
                :class="{ 'btn-outline-active': checkAll }">
          {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
        </button>
			</div>
   
		</div>
		
		<div class="row mt-2">
			<div class="col-md-12">
				
				<table class="table table-borderless table-dfe">
					<thead>
						<tr>
              <th>
                <BkpsCheckBox v-if="alerts.length > 0" @input="changeCheckAllRow" :value="checkAllRow"/>
              </th>
							<th>Estabelecimento</th>
							<th>Prestador</th>
							<th>Origem</th>
							<th>Mensagem</th>
							<th>Criado em</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="alert in alerts" :key="alert.id">
              <td>
                <BkpsCheckBox @input="changeCheckRow(alert)" :value="alert.checked"/>
              </td>
							<td>{{ alert.cnpj | cnpj }}</td>
							<td>{{ alert.cnpjProvider | cnpj }}</td>
							<td>{{ alert.originFormatted }}</td>
							<td>{{ alert.message }}</td>
							<td>{{ alert.createdAt | datetime }}</td>
							<td>
								<button v-if="$utils.isNotEmpty(alert.detail)" class="btn btn-outline">Detalhe</button>
							</td>
						</tr>
					</tbody>
				</table>
				
				<div class="row">
					<div class="col-md-12 my-1">
						<Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import BadgeFilters from '@/components/shares/BadgeFilters'
  import Formatter from '@/models/Formatter'
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import CheckedModels from '@/mixins/CheckedModels'
	import Pagination from '@/components/shares/specialTag/Pagination'
	import ModelMapper from '@/mixins/ModelMapper'
	import Select2 from '@/components/shares/Select2'
	import { mask } from 'vue-the-mask'
	
	import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
	import { Filter } from '@/models/filter'

	export default {
		components: { BadgeFilters, BkpsCheckBox, ChevronDownIcon, Pagination, SearchIcon, Select2 },
		computed: {
			alerts() {
				return this.getModels || []
			},
      disabledDownload() {
        return !this.alerts.some(alert => alert.checked)
      }
		},
		created() {
			this.defaultModelSetting.updateQueryURL = true
			this.methods = ['origin_formatted']
			this.addOrderBy('createdAt')
			
			this.$set(this.query, 'cnpjProvider', '')
			
			if (this.$utils.isEmpty(this.query.startDate)) {
				const date = new Date()
				date.setDate(date.getDate() - 1)
				this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))
			}
			
			this.asyncTemplateSelect({
				after: () => this.loadAllFilter(),
				byURL: true,
				pagination: true
			})
		},
		data() {
			return {
				filterCnpjProvider: new Filter({
					key: 'cnpjProvider',
					label: 'CNPJ Prestador',
					type: 'input'
				}),
				filterCompany: null,
				filterEndDate: new Filter({
					key: 'endDate',
					label: 'Data final',
					type: 'date'
				}),
				filterGeneric: new Filter({
					key: 'generic',
					label: 'Pesquisa por conteúdo'
				}),
        filterOrigin: null,
				filterStartDate: new Filter({
					key: 'startDate',
					label: 'Data inicial',
					type: 'date'
				}),
				modelPathPrefix: 'dfe',
				nameModel: 'Alert',
				showModal: false,
			}
		},
		directives: { mask },
		methods: {
      changeCheckAll() {
        this.changeCheck({checkAll: !this.checkAll, sources: this.alerts})
      },
      changeCheckAllRow() {
        this.changeCheck({ checkAllRow: !this.checkAllRow, sources: this.alerts })
      },
      changeCheckRow(alert){
        this.$set(alert, 'checked', !alert.checked)
        this.changeCheck({ sources: this.alerts })
      },
      cleanCheckRow() {
        this.checkAll = false
        this.checkAllRow = false
      },
      download() {
        const ids = this.alerts.filter(alert => alert.checked).map(alert => alert.id)
        if (!this.checkAll && ids.length === 0)
          return
  
        const byIds = !this.checkAll || ids.length < 10
        const message = byIds ? `Exportar ${ids.length} linhas?` : 'Exportar todas as linhas?'
        
        if (!confirm(message))
          return
        
        const path = 'dfe/alerts/download'
        const params = byIds ? { q: { id: ids } } : this.buildParams()
  
        this.axios.get(`${path}`, { params: params })
          .then(response => response.data)
          .then(data => {
            if (data.link)
							this.$parse.downloadByLink(data.link)
            else if (data.notice)
              this.$notify.add(data.notice, { closingTime: 12000 })
          })
					.catch(e => this.$notify.addError(e))
      },
			find() {
        this.cleanCheckRow()
				this.asyncTemplateSelect()
			},
      async loadAllFilter() {
        await this.loadFilterCompany()
        await this.loadFilterOrigin()
      },
			async loadFilterCompany() {
				const keyLocalStorage = 'lastFilterCompanyOfDFe'
				const label = 'Estabelecimento'
				const key = 'cnpj'
				
				let options = this.$ls.get(keyLocalStorage)
				if (options)
					this.filterCompany = new Filter({ key, label, table: options })
				
				let response = await this.axios.get('companies', {
					params: {
						per_page: 1000,
						query: { type: ['parent', 'subsidiary'] }
					}
				})
				
				options = response.data.map(c => [
					`${c.name} - ${Formatter.cnpj(c.cnpj)}`, c.cnpj]
				)
				
				this.filterCompany = new Filter({key, label, table: options})
				this.$ls.set(keyLocalStorage, options, { minutes: 60 * 24 })
			},
      async loadFilterOrigin() {
        const keyLocalStorage = 'lastFilterOriginOfDFe'
        const label = 'Origem'
        const key = 'origin'
        
        let options = this.$ls.get(keyLocalStorage)
        
        if (options) {
          this.filterOrigin = new Filter({
            key, label, table: options
          })
        }
        
        const response = await this.axios.get('dfe/alerts/origins')
        options = Object.entries(response.data).map(([key, value]) => [value, key])
        
        this.filterOrigin = new Filter({ key, label, table: options })
        this.$ls.set(keyLocalStorage, options, { minutes: 60 * 12 })
      },
			setCnpjProvider(event) {
				const value = event.target.value
				if (value)
					this.query.cnpjProvider = value.replace(/[-//.]/g, '')
			}
		},
		mixins: [CheckedModels, ModelMapper],
		name: 'Alert'
	}
</script>

<style scoped>

</style>